import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Section as commonSection,
  Wrapper as commonWrapper,
  Content as commonContent,
  Panel as commonPanel,
  PanelInner as commonPanelInner,
  Information as commonInformation,
  Text as commonText,
} from '../../assets/Common/Content.style';

import { Button as commonButton } from '../../assets/Common/Button.style';
import { Center as commonCenter } from '../../assets/Common/Center.style';

export const Section = styled.div`
  ${commonSection}
`;

export const Wrapper = styled.div`
  ${commonWrapper}
`;

export const Content = styled.div`
  ${commonContent}
`;

export const Panel = styled.div`
  ${commonPanel}
`;

export const PanelInner = styled.div`
  ${commonPanelInner}
`;

export const Center = styled.div`
  ${commonCenter}
`;

export const Information = styled.div`
  ${commonInformation}
  max-width: 530px;
  text-align: center;
`;

export const Text = styled.p`
  ${commonText}
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 300px;
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(535px, 1fr));
  grid-gap: 30px;
  padding: 60px 30px 30px;

  ${Media.lg`
    grid-template-columns: 1fr;
    grid-gap: 20px;
    padding: 20px 0;
  `}
`;
